window.DemoRequestAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    self.sendDemoRequest = function (data) {
        var deferred = $q.defer();
        _protected.request('non_user_demo_request', 'POST', data).then(function(res) {
            if (!res.data || !res.data.data || res.data.status_code != 200) {
                deferred.reject(res);
            }else{
                deferred.resolve(res.data.data);
            }
        }, function(err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };
});
